export const environment = {
  production: false,
  apiUrl: 'https://api-dev-logame-bets-bko.officecom.app',
  apiKey: 'TZAC_n5sY9JlQfI_4d0F4M5_bxM6moEG',
};
